export const NAME = 'filters';

/**
 * Filters
 */
export const FILTER_PARTNER_ON_FIRST_LETTER = 'FILTER_PARTNER_ON_FIRST_LETTER';
export const FILTER_PARTNER_ON_CATEGORY = 'FILTER_PARTNER_ON_CATEGORY';

/**
 * Sort
 */
export const SORT_PARTNER_ON_NAME = 'SORT_PARTNER_ON_NAME';
export const SORT_PARTNER_ON_ORDER = 'SORT_PARTNER_ON_ORDER';
export const SORT_PARTNER_ON_CASHBACK = 'SORT_PARTNER_ON_CASHBACK';
export const SORT_PARTNER_ON_CASHBACK_OFFLINE = 'SORT_PARTNER_ON_CASHBACK_OFFLINE';
export const SORT_PARTNER_ON_CASHBACK_EBON = 'SORT_PARTNER_ON_CASHBACK_EBON';
export const SORT_PARTNER_ON_CREATION_DATE = 'SORT_PARTNER_ON_CREATION_DATE';
export const SORT_PARTNER_ON_NB_COUPON = 'SORT_PARTNER_ON_NB_COUPON';

/**
 * Clear
 */
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const CLEAR_SORT = 'CLEAR_SORT';

/**
 *  Pages
 *  Every filter is inside a page context to keep in mind during navigation
 */
export const PAGE_DIRECTORY = 'directory';



// WEBPACK FOOTER //
// ./src/services/filter/constants.js